module.exports = new __parcel__URL__("not-found.52011569.svg").toString();